import M$plugin$Managegrid from 'C:/proyectos/managegrid/src/facade/js/managegrid';
import M$control$ManagegridControl from 'C:/proyectos/managegrid/src/facade/js/managegridcontrol';
import M$impl$control$ManagegridControl from 'C:/proyectos/managegrid/src/impl/ol/js/managegridcontrol';

if (!window.M.plugin) window.M.plugin = {};
if (!window.M.control) window.M.control = {};
if (!window.M.impl) window.M.impl = {};
if (!window.M.impl.control) window.M.impl.control = {};
window.M.plugin.Managegrid = M$plugin$Managegrid;
window.M.control.ManagegridControl = M$control$ManagegridControl;
window.M.impl.control.ManagegridControl = M$impl$control$ManagegridControl;
